<p-dialog
  header="Transfer Context"
  [(visible)]="visible"
  [modal]="true"
  [style]="{ width: '32rem', maxWidth: '95vw' }"
  [draggable]="false"
  [resizable]="false"
  [closable]="!saving"
  [closeOnEscape]="!saving"
  (onHide)="closed.emit()"
>
  <p>Transfer ownership of Context <strong>{{ project?.name }}</strong> to:</p>
  <div class="p-fluid">
    <div class="p-field">
      <label for="transferAccount">Account</label>
      <p-autoComplete
        inputId="transferAccount"
        [ngModel]="account"
        (ngModelChange)="accountChanged($event)"
        [showEmptyMessage]="accounts !== null && accounts.length === 0"
        [suggestions]="accounts"
        (completeMethod)="searchAccounts($event)"
        field="name"
        [forceSelection]="false"
        [disabled]="saving"
        appendTo="body"
        placeholder="Search accounts"
        emptyMessage="No accounts found"
      ></p-autoComplete>
    </div>
    <div class="p-field">
      <label for="transferUser">User</label>
      <p-dropdown
        inputId="transferUser"
        [(ngModel)]="user"
        [options]="users"
        optionLabel="label"
        dataKey="userId"
        [disabled]="!selectedAccount || loadingUsers || saving"
        appendTo="body"
        placeholder="Select a user"
        emptyMessage="No users found in this account"
      ></p-dropdown>
      <small *ngIf="!selectedAccount">Select an account first.</small>
      <small *ngIf="loadingUsers" role="status">Loading users…</small>
    </div>
  </div>
  <p *ngIf="error" class="p-error" role="alert">{{ error }}</p>
  <ng-template pTemplate="footer">
    <p-button
      icon="pi pi-check"
      type="button"
      [label]="saving ? 'Transferring…' : 'Transfer'"
      class="p-mr-2 save"
      [disabled]="!canTransfer"
      (click)="transfer()"
    ></p-button>
    <p-button
      icon="pi pi-times"
      type="button"
      label="Cancel"
      styleClass="p-button-raised p-button-secondary p-button-text"
      [disabled]="saving"
      (click)="closed.emit()"
    ></p-button>
  </ng-template>
</p-dialog>
